import { createReducer } from 'redux-act';
import * as actions from './actions';

const initialState = {
  presentation: {},
  presentationPreview: {},
  presentationLocale: '',
  presentationUrl: '',
  indexH: 0,
  questionSet: null,
};

const presentationReducer = createReducer(
  {
    [actions.updatePresentation]: (state, payload) => {
      return {
        ...state,
        presentation: payload || {},
      };
    },
    [actions.updatePresentationFields]: (state, payload) => {
      return {
        ...state,
        presentation: { ...state.presentation, ...payload },
      };
    },
    [actions.updatePresentationPreview]: (state, payload) => {
      return {
        ...state,
        presentationPreview: payload || {},
      };
    },
    [actions.updatePresentationLocale]: (state, payload) => {
      return {
        ...state,
        locale: payload || {},
      };
    },
    [actions.clearPresentation]: () => {
      return initialState;
    },
    [actions.updatePresentationUrl]: (state, payload) => {
      return {
        ...state,
        presentationUrl: payload || '',
      };
    },
    [actions.updateIndexH]: (state, payload) => {
      return {
        ...state,
        indexH: payload || 0,
      };
    },
    [actions.updateQuestionSet]: (state, payload) => {
      return {
        ...state,
        questionSet: payload || null,
      };
    },
  },
  initialState
);

export default presentationReducer;
